/* global G */

import { getFirstItem, isArr } from 'lib/util'

const _hasValue = value => (value || value === 0)
  && isArr(value) ? value.length : value

/**
 *
 * Model Confirmation Validator
 *
 * validates data values on model level, propagating
 * to the same scope as children validators
 *
 * @param {Object} obj  the model object composition
 * @returns {Object}     the call's arguments
 */
export default obj => async (uiState, key) => {
  const { value } = uiState
  const { options } = obj[G.CONFIGURATION].validator[key]
  const { target, error } = options

  // Getting the cache of the target (supportedBy or parent) and use it as a fallback
  const targetCache = getFirstItem(obj[G.CHILDREN][target]?.[G.CACHE]) || null

  const { [target]: targetFieldValue } = obj[G.DATA]

  if (!_hasValue(value) && !(_hasValue(targetFieldValue) || targetCache)) {
    throw TypeError(error)
  }
  return [uiState, key]
}
